import { Box } from '@mui/system';
import { RichTextInput } from 'ra-input-rich-text';
import * as React from 'react';
import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
} from 'react-admin';

export default function ResourceCreate(props: any) {
  return (
    <Box sx={styles.boxStyle}>
      <Create sx={styles.createStyle} {...props}>
        <SimpleForm style={styles.inputStyle}>
          <ReferenceInput label={'User'} source='userId' reference='user'>
            <SelectInput optionText='name' sx={styles.inputStyle} />
          </ReferenceInput>
          <TextInput source='shippingAddress' sx={styles.inputStyle} />
          <TextInput source='billingAddress' sx={styles.inputStyle} />
          <NumberInput source='total' sx={styles.inputStyle} />
          <NumberInput source='productsTotalPrice' sx={styles.inputStyle} />
          <TextInput source='discount' sx={styles.inputStyle} />
          <TextInput source='membershipDiscount' sx={styles.inputStyle} />
          <TextInput source='shippingPrice' sx={styles.inputStyle} />
          <TextInput source='tax' sx={styles.inputStyle} />
          <ReferenceInput label={'Coupon'} source='couponId' reference='coupon'>
            <SelectInput optionText='name' />
          </ReferenceInput>
          <TextInput source='paymentStatus' sx={styles.inputStyle} />
          <TextInput source='shipmentStatus' sx={styles.inputStyle} />
          <TextInput source='paymentMethod' sx={styles.inputStyle} />
          <TextInput source='paymentReference' sx={styles.inputStyle} />
          <TextInput source='shipmentRefernce' sx={styles.inputStyle} />
        </SimpleForm>
      </Create>
    </Box>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  createStyle: {
    width: '50%',
    minWidth: 250,
  },
  inputStyle: {
    width: '100%',
  },
};
